import { copyTextToSystemClipboard } from "@excalidraw/excalidraw/clipboard";
import { Dialog } from "@excalidraw/excalidraw/components/Dialog";
import { FilledButton } from "@excalidraw/excalidraw/components/FilledButton";
import { TextField } from "@excalidraw/excalidraw/components/TextField";
import { useState } from "react";

import { useAtom } from "../../app-jotai";
import { shareLinkDialogAtom } from "../dialogState";

export const ShareLinkDialog = () => {
  const [state, setState] = useAtom(shareLinkDialogAtom);
  const [copied, setCopied] = useState(false);

  if (!state.isOpen) {
    return null;
  }

  const close = () => {
    setState({ isOpen: false });
    setCopied(false);
  };

  const copy = async () => {
    try {
      await copyTextToSystemClipboard(state.url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2500);
    } catch {
      // ignore
    }
  };

  const expiryText = state.expiresAt
    ? `Expires ${new Date(state.expiresAt * 1000).toLocaleString()}`
    : "This link never expires.";

  return (
    <Dialog size="small" onCloseRequest={close} title="Shareable link">
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <div style={{ fontSize: "0.9rem", lineHeight: 1.5 }}>
          Anyone signed in who has this link can open a copy of this drawing.
        </div>
        <div style={{ display: "flex", gap: "0.5rem", alignItems: "flex-end" }}>
          <TextField
            label="Link"
            value={state.url}
            readonly
            fullWidth
            onChange={() => {}}
          />
          <FilledButton label={copied ? "Copied!" : "Copy"} onClick={copy} />
        </div>
        <div style={{ fontSize: "0.8rem", color: "var(--color-gray-60)" }}>
          {expiryText}
        </div>
      </div>
    </Dialog>
  );
};
